import Footer from "components/Website/Layouts/Footer";
import Navbar from "components/Website/Layouts/Navbar";
import { Link } from "react-router-dom";
import imgPromise from "assets/images/verification-img.png";
import customer from "assets/images/website/icons/customer.png";
import excellence from "assets/images/website/icons/excellence.png";
import innovation from "assets/images/website/icons/innovation.png";
import integrity from "assets/images/website/icons/integrity.png";
import { useTranslation } from "react-i18next";
import "./styles.scss";
import HearForm from "../Home/HearForm";
import { useState } from "react";
import {
	Accordion,
	AccordionBody,
	AccordionHeader,
	AccordionItem,
} from "react-bootstrap";

function AboutUs() {
	const { t } = useTranslation();
	const [open, setOpen] = useState("1");
	const toggle = (id) => {
		if (open === id) {
			setOpen();
		} else {
			setOpen(id);
		}
	};
	return (
		<>
			<Navbar />
			<div className="websitPages">
				<div className="about-page">
					<div className="about-head">
						<div className="about-head-min">
							<p className="title">
								<span className="gotham-font text-primary">{t("About")}</span>{" "}
								<span className="bask-font text-primary ">{t("Company")}</span>
							</p>
							<p className="des1 mb-5">
								Meras is a premier real estate company committed to
								revolutionizing your property buying and selling experience
								through our innovative online platform. With Meras, discovering
								your dream home or securing the best deal for your property has
								never been easie
							</p>
							<p className="des2">
								Meras goes beyond the traditional real estate transaction by
								offering a range of value-added services.From mortgage
								assistance to legal guidance and property management solutions,
								we strive to be your one-stop destination for all your real
								estate needs.
							</p>
						</div>
					</div>
					<div className="vision-mission">
						<div className="container">
							<p className="title bask-font text-primary">
								{t("vision & mission")}
							</p>
							<div className="vision-mission-details d-md-flex">
								<div className="vision-details">
									<p className="title">{t("vision")}</p>
									<p className="details">
										To redefine the real estate industry by leveraging
										technology and innovation, providing a seamless online
										experience, and becoming the trusted partner for individuals
										and businesses in their property endeavors.
									</p>
								</div>
								<div className="mission-details">
									<p className="title">{t("mission")}</p>
									<p className="details">
										At Meras, our mission is to empower our clients with a
										transformative online platform that simplifies the process
										of buying, selling, and investing in real estate. We strive
										to deliver exceptional value through personalized service,
										cutting-edge technology
									</p>
								</div>
							</div>
						</div>
					</div>
					<div className="container pb-5">
						<div className="our-core">
							<p className="title">
								<span className="gotham-font text-white">{t("our core")}</span>{" "}
								<span className="bask-font text-white ">{t("values")}</span>
							</p>
							<div className="row our-core-values">
								<div className="col-xl-3 col-md-6 pt-5 pt-xl-0">
									<div className="integrity text-center">
										<img src={integrity} alt="integrity" />
										<p>{t("integrity")}</p>
										<span>
											We operate with honesty, transparency, and ethical
											standards, building trust with our clients and fostering
											long-term relationships based on integrity.
										</span>
									</div>
								</div>
								<div className="col-xl-3 col-md-6 pt-5 pt-xl-0">
									<div className="innovation text-center">
										<img src={innovation} alt="innovation" />
										<p>{t("innovation")}</p>
										<span>
											We embrace technology and continuously seek innovative
											solutions to enhance the real estate experience, providing
											our clients with a distinct advantage in the market.
										</span>
									</div>
								</div>
								<div className="col-xl-3 col-md-6 pt-5 pt-xl-0">
									<div className="customer text-center">
										<img src={customer} alt="customer" />
										<p>{t("customer centricity")}</p>
										<span>
											We prioritize our clients' needs and concerns, delivering
											personalized service, prompt responses, and tailored
											solutions to exceed their expectations.
										</span>
									</div>
								</div>
								<div className="col-xl-3 col-md-6 pt-5 pt-xl-0">
									<div className="excellence text-center">
										<img src={excellence} alt="excellence" />
										<p>{t("excellence")}</p>
										<span>
											We strive for excellence in every aspect of our
											operations, from the quality of our listings to the
											professionalism of our agents, ensuring that our clients
											receive the highest level of service.
										</span>
									</div>
								</div>
							</div>
						</div>
						<div className="our-developers">
							<div className="d-md-flex justify-content-between align-items-center">
								<p
									className="title"
									dangerouslySetInnerHTML={{
										__html: t("our developers"),
									}}></p>
								<span className="text-primary developers-text">
									LOREM IPSUM DOLOR SIT AMET, CONSECTETUER ADIPISCING ELIT , SED
									DIAM NONUMMY NIBH UT LAOREET DOLORE MAGNA
								</span>
							</div>
						</div>
					</div>
					<div className="faqs">
						<div className="container">
							<div>
								<p
									className="title"
									dangerouslySetInnerHTML={{
										__html: t("faqs about"),
									}}></p>
								<Accordion defaultActiveKey="0">
									<AccordionItem eventKey="0">
										<AccordionHeader>
											Lorem Ipsum is simply dummy text of the printing and
											typesetting industry?
										</AccordionHeader>
										<AccordionBody>
											Lorem Ipsum is simply dummy text of the printing and
											typesetting industry?
										</AccordionBody>
									</AccordionItem>
									<AccordionItem eventKey="1">
										<AccordionHeader>
											Lorem Ipsum is simply dummy text of the printing and
											typesetting industry?
										</AccordionHeader>
										<AccordionBody>
											Lorem Ipsum is simply dummy text of the printing and
											typesetting industry?
										</AccordionBody>
									</AccordionItem>
								</Accordion>
							</div>
						</div>
					</div>
					<HearForm />
				</div>
			</div>
			<Footer />
		</>
	);
}

export default AboutUs;
